export const isFetching = state => state.modules.templates.fetching;
export const templates = state => state.modules.templates.templates;
